module.exports = new __parcel__URL__("marine-lg.7a0d14d3.jpg").toString();